import TextInput from "./TextInput";
import { validateEmail } from "../../utils/validation";

function EmailInput({...props}) {
    return (
        <TextInput validation={validateEmail} {...props} />
    );
}

export default EmailInput;